import script from "./RouteItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouteItem.vue?vue&type=script&setup=true&lang=ts"

import "./RouteItem.vue?vue&type=style&index=0&id=e61be0c0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e61be0c0"]])

export default __exports__